import React from 'react'
import TestApi from '../pages/TestApi';
import Menu from '../pages/public/Menu';
import { useSelector } from 'react-redux';
import Form from '../pages/public/form/Form';
import MajorError from '../errors/MajorError';
import Vr from "../pages/public/activities/Vr";
import Preview from '../pages/private/Preview';
import MenuShow from '../pages/public/MenuShow';
import Rules from '../pages/public/activities/Rules';
import Price from '../pages/public/activities/Price';
import Laser from '../pages/public/activities/Laser';
import Arcade from '../pages/public/activities/Arcade';
import Profile from '../pages/private/profile/Profile';
import RegisterShow from '../pages/public/RegisterShow';
import PartyRoom from '../pages/public/rooms/PartyRoom';
import HyperSurvery from '../pages/public/HyperSurvery';
import Homepage from '../pages/public/homepage/Homepage';
import NotFound from '../pages/public/notfound/NotFound';
import NewComp from '../pages/public/activities/NewComp';
import EliPlay from '../pages/public/activities/EliPlay';
import Bowling from '../pages/public/activities/Bowling';
import Karting from '../pages/public/activities/Karting';
import TermsConditions from '../pages/public/terms/Terms';
import { Route, Routes, Navigate } from "react-router-dom";
import UserWrapper from '../pages/public/user/UserWrapper';
import Recharge from '../pages/public/activities/Recharge';
import BusniessRoom from '../pages/public/rooms/BusniessRoom';
import EscapeRoom from '../pages/public/activities/EscapeRoom';
import ScoreBoard from '../pages/public/scoreboard/ScoreBoard';
import FaceBookTerms from '../pages/public/terms/FaceBookTerms';
import BirthdayRoom2 from '../pages/public/rooms/BirthdayRoom2';
import AxeThrowing from '../pages/public/activities/AxeThrowing';
// import HyperStrike from '../pages/public/activities/HyperStrike';
import ForgetPassword from '../pages/public/password/ForgetPassword';
import ChangePassword from '../pages/public/password/ChangePassword';
import MyReservation from '../pages/private/dashboard/MyReservation';
import RegisterVerification from '../pages/public/register/RegiisterVerification';
import PaymentVerification from '../pages/private/reservation/PaymentVerification';
import Canvas from '../components/builder/Canvas';
import Register from '../pages/public/register/Register';
import ReservationModule from '../pages/private/reservation/ReservationModule';
import Checkout from '../pages/private/reservation/Checkout';
import ReservationActivities from '../pages/private/reservation/ReservationActivities';
import MobileVerification from '../pages/public/MobileVerification';


// Disabled Start
// import CardTopUp from '../pages/private/cardPopUp/CardTopUp';
// import CardRefill from '../pages/private/cardPopUp/CardRefill';
// import CardHistory from '../pages/private/cardPopUp/CardTopHistory';
// Disabled End

export default function Router() {
    const ProtectedRoute = ({ children, from }) => {
        const { authenticated } = useSelector((state) => state.auth);
        return authenticated ? <>{children}</> : <Navigate to="/login" state={{ from: from }} />;
    };

    const PublicRoute = ({ children }) => {
        const { authenticated } = useSelector((state) => state.auth);
        return authenticated ? <Navigate to="/reservation" /> : <>{children}</>;
    };

    return (
        <Routes>

            <Route path="/" element={<Homepage />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/removedata" element={<FaceBookTerms />} />

            <Route path="/activities/karting" element={<Karting />} />
            <Route path="/karting/scoreboard" element={<ScoreBoard />} />
            <Route path="/activities/laser" element={<Laser />} />
            <Route path="/activities/hyperstrike" element={<Canvas />} />
            <Route path="/activities/arcade" element={<Arcade />} />
            <Route path="/activities/virtual" element={<Vr />} />
            <Route path="/activities/bowling" element={<Bowling />} />
            <Route path="/activities/axe" element={<AxeThrowing />} />
            <Route path="/activities/eli" element={<EliPlay />} />
            <Route path="/activities/escape" element={<EscapeRoom />} />
            <Route path="/activities/laser" element={<NewComp />} />
            <Route path="/activities/recharge" element={<Recharge />} />
            <Route path="/activities/bussiness" element={<BusniessRoom />} />
            <Route path="/activities/party" element={<PartyRoom />} />
            <Route path="/activities/birthday" element={<BirthdayRoom2 />} />
            <Route path="/activities/rules" element={<Rules />} />
            <Route path="/activities/price" element={<Price />} />
            
            <Route path="/hyper/regsiter" element={<RegisterShow />} />
            <Route path="/hyper/hypersurvey/:id" element={<HyperSurvery />} />
            
            <Route path="/payment/:type" element={<PaymentVerification />} />
            
            <Route path="/menu/" element={<Menu />} />
            <Route path="/menu/:id" element={<MenuShow />} />
            
            <Route path="/YWRzYTIxM2Z3YTQyMTRlYXdkcw" element={<Form />} />
            <Route path="/preview/:id" element={<Preview />} />
            
            <Route path="/login" element={<PublicRoute><UserWrapper /></PublicRoute>} />
            <Route path="/register" element={<PublicRoute><Register /></PublicRoute>}/>
            <Route path="/verification/:id" element={<PublicRoute><RegisterVerification /></PublicRoute>} />
            
            <Route path="/password" element={<PublicRoute><ForgetPassword /></PublicRoute>} />
            <Route path="/password/:token" element={<PublicRoute><ChangePassword /></PublicRoute>}/>
            
            <Route path="/reservation" element={<ReservationActivities />} />
            <Route path="/reservation/:id" element={<ReservationModule />} />
            
            <Route path="/cart" element={<Checkout />} />
            
            <Route path="/user/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/user/reservation" element={<ProtectedRoute><MyReservation /></ProtectedRoute>} />

            {/* 
            <Route path="/cart" element={<CardTopUp />} />
            <Route path="/card/:id" element={<CardHistory />} />
            <Route path="/card/refill/:id" element={<CardRefill />} /> 
            */}
            <Route path="/v/:id" element={<MobileVerification />} />
            <Route path="/test" element={<TestApi />} />    
            <Route path="/error" element={<MajorError />} />
            <Route path="/*" element={<NotFound />} />
        </Routes>
    )
}